const PreProposalActionTypes = {
  PREPROPOSAL_LIST_ALL_START: "preproposal_list_all_start",
  PREPROPOSAL_LIST_ALL_SUCCESS: "preproposal_list_all_success",
  PREPROPOSAL_LIST_ALL_FAILURE: "preproposal_list_all_failure",
  PREPROPOSAL_LIST_ALL_RESET_START: "preproposal_list_all_reset_start",
  PREPROPOSAL_LIST_ALL_CHANGED: "preproposal_list_all_changed",

  PREPROPOSAL_LIST_SEARCH_START: "preproposal_list_search_start",
  PREPROPOSAL_LIST_SEARCH_SUCCESS: "preproposal_list_search_success",
  PREPROPOSAL_LIST_SEARCH_FAILURE: "preproposal_list_search_failure",
  PREPROPOSAL_LIST_SEARCH_RESET_START: "preproposal_list_seach_reset_start",
  PREPROPOSAL_LIST_SEARCH_CHANGED: "preproposal_list_search_changed",

  PREPROPOSAL_PUSH_TO_DIAL_START: "preproposal_push_to_dial_start",
  PREPROPOSAL_PUSH_TO_DIAL_SUCCESS: "preproposal_push_to_dial_success",
  PREPROPOSAL_PUSH_TO_DIAL_FAILURE: "preproposal_push_to_dial_failure",
  PREPROPOSAL_PUSH_TO_DIAL_RESET: "preproposal_push_to_dial_reset",
};
export default PreProposalActionTypes;
